import {Banners} from './banners';

export default Banners;